import React from 'react'
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../grid-container/GridContainer"


export function UiHowSectionWorkCol(props) {


    return (
        <>
            <UiCol lg="4" className="sb-how-section-work-border">
                <div className='sb-how-section-work'>
                    <div className='sb-how-section-work__left-col'>
                        <h4>{props.heading}</h4>
                        <p>{props.content}</p>
                    </div>
                    <div className='sb-how-section-work__right-col'>
                        <img src={props.image} />
                    </div>
                </div>
            </UiCol>

        </>
    )
}

export function UiHowSectionWorkColHeading(props) {


    return (
        <>
           
                <div className='sb-how-section-work-heading'>
                  <h3>{props.title}</h3> 
                </div>
           

        </>
    )
}
